import { Directive, HostListener, ElementRef } from '@angular/core';
import { NgControl, AbstractControl, ValidationErrors, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[phoneMask]',
  standalone: true,
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: PhoneMaskDirective,
      multi: true
    }
  ]
})
export class PhoneMaskDirective implements Validator {

  constructor(
    private control: NgControl,
    private el: ElementRef<HTMLInputElement>
  ) {}

 
  private formatPhoneNumberValue(input: string): string {
    if (!input) return '';
    
    
    input = input.replace(/[a-zA-Z]/g, '');
    
    
    if (input.startsWith('+1')) {
      if (input.length > 2 && input[2] !== ' ') {
        input = '+1 ' + input.slice(2);
      }
      let numberPart = input.startsWith('+1 ') ? input.slice(3) : input.slice(2);
      let digits = numberPart.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)} ${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return input.startsWith('+1 ') ? '+1 ' + formatted : '+1' + formatted;
    }
    

    if (input.startsWith('(')) {
      let digits = input.replace(/\D/g, '');
      if (digits.length > 10) digits = digits.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)} ${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    
    if (/^\d+$/.test(input)) {
      let digits = input.substring(0, 10);
      let formatted = digits;
      if (digits.length > 6) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3, 6)} ${digits.substring(6)}`;
      } else if (digits.length > 3) {
        formatted = `(${digits.substring(0, 3)}) ${digits.substring(3)}`;
      } else if (digits.length > 0) {
        formatted = `(${digits}`;
      } else {
        formatted = '';
      }
      return formatted;
    }
    
   
    if (input === '+' || input === '+1' || input === '+1 ') {
      return input;
    }
    
    
    return '';
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {
    const formatted = this.formatPhoneNumberValue(event.target.value);
    this.control.control?.setValue(formatted, { emitEvent: false });
    event.target.value = formatted;
  }

  @HostListener('blur')
  onBlur(): void {
    this.control.control?.updateValueAndValidity();
  }

  
  validate(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    
    if (!value) {
      return null; 
    }

    // Check pattern: should match (XXX) XXX XXXX or +1 (XXX) XXX XXXX
    const pattern = /^(\+1[ ]?)?\(\d{3}\)[ ]?\d{3}[ ]\d{4}$/;
    if (!pattern.test(value)) {
      return { pattern: true };
    }

    // Check max length (17 characters for +1 (XXX) XXX XXXX)
    if (value.length > 17) {
      return { maxlength: true };
    }

    // Extract digits and validate content
    let digits = value.replace(/\D/g, '');
    
    // If starts with 1, remove it (from +1)
    if (digits.length === 11 && digits.startsWith('1')) {
      digits = digits.substring(1);
    }

    // Check if all digits are zeros
    if (digits.length === 10 && /^0+$/.test(digits)) {
      return { allZeros: true };
    }

    return null;
  }
}
